import { RootState } from "@/store/store";
import { ModuleTree } from "vuex";
import { studyActions } from "./study.actions";
import { studyMutations } from "./study.mutations";
import { studyState } from "./study.state";

export default {
    namespaced: true,
    state: studyState,
    actions: studyActions,
    mutations: studyMutations,
} as unknown as ModuleTree<RootState>;